export default __webpack_public_path__ + "static/media/story_img_5.6893f383.jpeg";